import parentApi from "store/parentApi"
import { convertQueryObjToString } from "utils"

const invoiceSummaryApi = parentApi.injectEndpoints({
  endpoints: (build) => ({ 
    getInvoiceSummary: build.query({
      query: (params) => `/billableinvoices/${params.id}/summary`,
    }),
    getInvoicedLeads: build.query({
      query: (params) => `/billableinvoices/${params.id}/summaryInvoicedLeads?pageOffset=${params.pageOffset}`,
    }),
  }),
  overrideExisting: false,
});


export const {
    useLazyGetInvoiceSummaryQuery,
    useLazyGetInvoicedLeadsQuery

} = invoiceSummaryApi
